import { TextButton } from "@root/shared/components/TextButton";
import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  onClick: () => void;
};

export const NoShopBox: FC<Props> = ({ onClick }) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.text}>見つからないときは...</p>
      <TextButton size="small" rightIconName="arrow-light-right" onClick={onClick}>
        店舗を指定せず投稿
      </TextButton>
    </div>
  );
};
